import React from 'react'

import classNames from 'clsx'
import i18n from 'i18n-literally'
import PropTypes from 'prop-types'
import { isEmpty } from 'ramda'
import { useConnect } from 'redux-bundler-hook'

import { Warning as WarningIcon } from '@mui/icons-material'

import { subscriptionBannerData } from '~/src/Account/Management/utils'
import { useAllowed } from '~/src/Flags'
import createLogger from '~/src/Lib/Logging'
import T from '~/src/UI/Shared/Typography'

const displayName = 'SubscriptionBanner'
const logger = createLogger(displayName)

const SubscriptionBanner = ({ classes, bannerData }) => (
  <div
    className={classNames({
      [classes.bannerContainer]: true,
      [classes.bannerOverdue]: bannerData.type === 'overdue',
      [classes.bannerWarning]: bannerData.type === 'warning'
    })}
  >
    <WarningIcon />
    <T.Subtitle>
      {i18n`${bannerData.message}`}
    </T.Subtitle>
  </div>
)

SubscriptionBanner.displayName = displayName
SubscriptionBanner.propTypes = {
  bannerData: PropTypes.shape({
    message: PropTypes.string,
    type: PropTypes.string,
  }).isRequired
}

const Wrapped = React.memo(props => {
  const {
    accountSubscription,
    currentFacility
  } = useConnect('selectAccountSubscription', 'selectCurrentFacility')
  const [showBanner] = useAllowed({ features: 'CRM_INTEGRATION' })

  if (!showBanner) return null
  const bannerData = subscriptionBannerData(
    accountSubscription?.subscriptionEndDate ?? currentFacility?.subscriptionEndDate,
    currentFacility?.status,
    currentFacility?.invoicePastDue
  )
  return isEmpty(bannerData) ? null : <SubscriptionBanner {...props} bannerData={bannerData} />
})

export default Wrapped
